export const DASHBOARD_PERF_LOG = true;

interface PerfMark {
  label: string;
  ms: number;
}

const dashboardPerfMarks: PerfMark[] = [];

export function perfMark(label: string, ms: number): void {
  if (!DASHBOARD_PERF_LOG) return;
  dashboardPerfMarks.push({ label, ms: Math.round(ms) });
}

export async function perfTime<T>(label: string, fn: () => T | Promise<T>): Promise<T> {
  if (!DASHBOARD_PERF_LOG) return fn();
  const t0 = performance.now();
  try { return await fn(); }
  finally { perfMark(label, performance.now() - t0); }
}

export function perfTimeSync<T>(label: string, fn: () => T): T {
  if (!DASHBOARD_PERF_LOG) return fn();
  const t0 = performance.now();
  try { return fn(); }
  finally { perfMark(label, performance.now() - t0); }
}

export function perfFlush(scope: string): void {
  if (!DASHBOARD_PERF_LOG || !dashboardPerfMarks.length) return;
  const marks = dashboardPerfMarks.splice(0);
  const total = marks.reduce((s, m) => s + m.ms, 0);
  console.log(
    `[dashboard-perf:${scope}] total=${total}ms ` +
    marks.map((m) => `${m.label}=${m.ms}ms`).join("  "),
  );
}
